<template>
    <Layout disable-vertical-padding disable-horizontal-padding>
        <div v-if="user" v-bind:class="$style.hero">
            <AppImage
                v-if="user.profile_image"
                v-bind:image="user.profile_image"
                v-bind:class="$style.image"
                crop-height="24rem"
            />
            <h1>{{ user.username }}</h1>
            <p>Comments: {{ user.__meta__.comments_count }}</p>
        </div>
    </Layout>
</template>

<script>
    import Layout from '@layouts/main';

    export default {
        /**
         * Custom page meta data property for the view components.
         *
         * @type {Object}
         */
        metaInfo () {
            return {
                title: this.username + ' Profile',
                meta: [
                    {
                        name: 'description',
                        content: 'Learn more about CitizenJ user ' + this.username + ' comment history.',
                    },
                ],
                link: [
                    {
                        rel: 'canonical',
                        href: '/user/' + this.$route.params.user + '/' + this.$route.params.variant,
                    },
                ],
            };
        },

        /**
         * Declaratively register required components.
         *
         * @link https://vuejs.org/v2/guide/components.html#Local-Registration
         */
        components: {
            Layout,
        },

        /**
         * You must define defaults for all Vue models and reactive Vue template data.
         *
         * @link https://vuejs.org/v2/api/#data
         *
         * @return Object Vue model and binding defaults.
         */
        data () {
            return {
                user: null,
            };
        },

        /**
         * This method logic will be run immediately after the Vue instance is created.
         *
         * @link https://vuejs.org/v2/guide/instance.html#Lifecycle-Diagram
         */
        created () {
            this.username = this.$route.params.user + '#' + this.$route.params.variant;
            this.axios.get('/user-profile', {
                params: {
                    username: this.username,
                },
            }).then(({ data }) => this.user = data);
        },
    };
</script>

<style lang="scss" module>
    @import '@design';

    .hero {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: calc(100vh - 8rem);
        text-align: center;
        background: #282B57;

        p:first-of-type {
            margin-top: 1rem;
            font-size: 2rem;
            font-weight: 900;
            line-height: 1;
            color: #EF4141;
        }

        p:nth-of-type(2) {
            font-size: 1.25rem;
            color: #FFF;
        }

        h1 {
            @apply my-0;
            font-size: 3.5rem;
            font-weight: 900;
            line-height: 1;
            color: white;

            @screen lg {
                font-size: 8rem;
            }
        }

        button {
            padding: 2rem 4rem;
            margin-top: 3rem;
            font-size: 1.25rem;
            font-weight: 900;
            color: white;
            text-align: center;
            border: 1px solid white;

            @screen lg {
                padding: 2rem 4rem;
                font-size: 1.5rem;
            }
        }
    }

    .featured {
        @apply flex -mx-2 px-10 py-6 bg-gray-400;
    }

    .featured__card {
        @apply flex-1;
    }

    .websites {
        @apply flex flex-wrap px-10 py-6 -mx-2;
    }

    .websites__card {
        @apply w-1/3 m-0 py-6;
    }
</style>
